import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DateTimeModule } from '@y42/date-time';
import { DatePickerComponent } from '../components/date-picker/date-picker.component';
import { RangePickerComponent } from '../components/range-picker/range-picker.component';
import { TimeSelectorComponent } from '../components/time-selector/time-selector.component';
import { DaterangePickerComponent } from './daterange-picker.component';

@NgModule({
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTooltipModule,
    MatButtonModule,
    ReactiveFormsModule,
    DateTimeModule,
    FontAwesomeModule,
    A11yModule,
  ],
  exports: [DaterangePickerComponent],
  declarations: [DaterangePickerComponent, DatePickerComponent, TimeSelectorComponent, RangePickerComponent],
})
export class DaterangePickerModule {}
